import {
  all,
  AllEffect,
  ForkEffect,
  StrictEffect,
  takeLatest,
  put,
  call,
  select,
} from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { BffCmsPromotionsResponse, BffResponse } from '@lucky7ventures/bff-types';
import BffApiService from '@/shared/bffApiService';
import {
  getPromotionsError,
  getPromotionsSuccess,
  PromotionsActionType,
} from '@/store/cms/promotions/actions';
import { selectUserBtagPrefix } from '@/store/selectors/combined.selectors';

export function* getPromotionsSaga(): Generator<
  StrictEffect,
  void,
  AxiosResponse<BffResponse<BffCmsPromotionsResponse>>
> {
  try {
    const btag = yield select(selectUserBtagPrefix);
    const response = yield call(BffApiService.getPromotions, {
      config: { params: { btag } },
    });

    if (response.data.data) {
      yield put(getPromotionsSuccess(response.data.data));
    }
  } catch (error) {
    yield put(getPromotionsError());
  }
}

export function* watchPromotionsSagas(): Generator<AllEffect<ForkEffect<never>>, void> {
  yield all([takeLatest(PromotionsActionType.GetPromotions, getPromotionsSaga)]);
}
